import { GET_CHAT, DISPLAY_INPUT_OPTION, UPDATE_USER_COUPON, SUBMIT_CHAT, FORCE_OPEN } from './type';
// import { getErrorCode } from '../../assets/util';
// import _ from 'lodash';


export function clearChat() {
    return (dispatch) => {
        dispatch({
            type: GET_CHAT,
            payload: null
        });
    }
}
export function getChat(fingerprint = null) {
    return (dispatch, getState, { axios, axNL }) => {
        return new Promise(resolve => {
            const id = getState().auth.user_id;

            // let id = profile? profile.user_id: null;

            //SEARCH
            // const params = {};
            // params.sort_type = type;
            // params.sort_order = order;
            // params.search_data = search;
            // params.page = page;
            // console.log("GET CHAT =>",id)
            // if(!id || id === -1){
            //     dispatch({
            //         type: GET_CHAT,
            //         payload: {login: false}
            //     });
            //     resolve();
            // }else{

            axNL.post(`/get_chat`, { id, fingerprint })
                .then((response) => {
                    // console.log ("Front end response", response);
                    dispatch({
                        type: GET_CHAT,
                        payload: response.data
                    });
                    resolve();
                })
                .catch((error) => {
                    // console.log (error);
                    dispatch({
                        type: GET_CHAT,
                        payload: null
                    });
                    resolve();
                })
            // }
        })
    }
}

export function toggleInputOption(visible) {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: DISPLAY_INPUT_OPTION,
            payload: visible
        })
    }
}

export function postSocketError(error) {
    return (dispatch, getState, { axios }) => {
        axios.post(`/socket_error`, {
            errLog: JSON.stringify(error)
        })
            .then((response) => {
                console.log("SOCKET ERROR")
            })
            .catch((error) => {

            })
    }
}

export function collectCoupon(obj, merge_chat = false, profile = null, fingerprint = null) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: UPDATE_USER_COUPON,
            payload: null
        })
        axios.post(`/chat/update/user_coupon`, {
            obj: obj,
            merge_chat: merge_chat,
            profile: profile,
            fingerprint: fingerprint
        })
            .then((response) => {
                dispatch({
                    type: UPDATE_USER_COUPON,
                    payload: true
                })
            })
            .catch((error) => {
                dispatch({
                    type: UPDATE_USER_COUPON,
                    payload: false
                })
            })
    }
}

export function submitChat(type, message) {
    return (dispatch, getState) => {
        if (!getState().auth.authenticated) {
            dispatch({
                type: FORCE_OPEN,
                payload: true
            })
        } else {
            const msg = (type === "product" || type === "order") ? JSON.stringify(message) : message
            dispatch({
                type: SUBMIT_CHAT,
                payload: { type: type, message: msg }
            })
        }
    }
}

export function clearSubmitChat() {
    return (dispatch) => {
        dispatch({
            type: SUBMIT_CHAT,
            payload: { type: null, message: null }
        })
    }
}

export function clearForceOpen() {
    return (dispatch) => {
        dispatch({
            type: FORCE_OPEN,
            payload: false
        })
    }
}
// export function mergeChat(){
//     return (dispatch, getState, {axios}) => {
//         dispatch({
//             type: MERGE_CHAT,
//             payload: null
//         })
//         axios.post(`/chat/merge_chat`, {
//         })
//         .then((response) => {
//             dispatch({
//                 type: MERGE_CHAT,
//                 payload: true
//             })
//         })
//         .catch((error) => {
//             dispatch({
//                 type: MERGE_CHAT,
//                 payload: false
//             })
//         })
//     }
// }